<p-confirmDialog key="staffnotify" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div class="MainDiv">
	<div class="MessageDiv" style="margin-bottom: 15px">
		<label>Message:</label>
		<input [disabled]="IsLoading() == true || HasUserAccount == false" type="text" class="form-control" style="margin-left: 5px" [(ngModel)]="Message" />
	</div>

	<div class="MessageDiv">
		<button [disabled]="IsLoading() == true || HasUserAccount == false" class="btn btn-primary" (click)="onSend()">Send Notification</button>
		<img class="info-img" (click)="onToggleInfo()" src="assets/images/info-24.png" />
	</div>
</div>

<div *ngIf="ShowInfo == true" class="InfoDiv">
	<label>&#9900; This page lets you send a notification to someone using the Staff Portal App</label><br />
	<label>&#9900; Select a staff member, type in a message, and press send to send a notification.</label><br />
	<label>&#9900; The message will show up as a Push Notification on the user's phone and will be visible in the app.</label><br />
</div>

<div *ngIf="SelectedPerson != undefined && IsLoading() == false && HasUserAccount == false" class="alert alert-warning">
	Staff member has not registered the Staff Portal App. Please have this staff member register the app or you won't be able to send them a notification.
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="ErrorMessage" *ngIf="ErrorMessage" class="alert alert-danger">{{ ErrorMessage }}</div>
</div>
